<template>
  <!-- 질문33,34 -->
  <v-layout flex-fill column class="survey-type-09">
    <div class="subheader">질문을 읽고 자신에게 해당되는 것에 표시해 주세요.</div>
    <div class="question" v-html="surveyData.startQues"></div>
    <div class="answer text-center flex-grow-0">
      <ToggleBtn :total="2" :flag="0" :minWidth="120" :str="[{'cd': 0, 'cdNm': '예'},{'cd': 1, 'cdNm': '아니오'}]"
                 @change="changed" :answer="answer"/>
    </div>
    <v-container fluid>
      <v-divider class="mt-5" />
    </v-container>
    <div class="question" v-html="surveyData.finishWord"></div>
    <div class="answer text-center flex-grow-0">
      <ToggleBtn :total="2" :flag="1" :minWidth="120" :str="[{'cd': 0, 'cdNm': '예'},{'cd': 1, 'cdNm': '아니오'}]"
                 @change="changed" :answer="answer"/>
    </div>
  </v-layout>
</template>

<script>
import ToggleBtn from '@/components/btns/ToggleBtn'
import store from '../../store'

export default {
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    answer: [],
    memberNo: 0
  }),
  components: {
    ToggleBtn,
  },
  mounted() {
    this.getStepLoadData();
  },
  created() {
    this.memberNo = this.$store.state.auth.authUser.userKey;
    // this.getStepLoadData();
  },
  methods: {
    changed(answer, flag) {
      this.answer[flag] = answer;
      this.$emit('emotionSelected', this.answer);
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 09 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data.reply != undefined && res.data.reply != null) {
              this.answer = res.data.reply.split('|');
              this.$emit('emotionSelected', this.answer);
            }
          } else {
            console.log(res.msg)
            this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          this.answer = [];
        })
        .finally(() => {
        })
    },
  }
}
</script>
